/* ==========================================================================
   B案: カードスライダー — スムーズスワイプ対応
   ========================================================================== */
(function () {
  var track = document.getElementById('fbTrack');
  var nav   = document.getElementById('fbNav');
  if (!track) return;

  var cards   = track.querySelectorAll('.fb-card');
  var navNums = nav ? nav.querySelectorAll('.fb-nav-num') : [];
  var total   = cards.length;
  var current = 0;

  var dragging = false;
  var startX = 0, startY = 0;
  var currentTx = 0;
  var dragDelta = 0;
  var direction = null; /* null | 'horizontal' | 'vertical' */
  var LOCK_THRESHOLD = 8; /* 方向確定の閾値px */

  var isMobile = function () { return window.innerWidth <= 768; };

  function measure() {
    var wrap = track.parentElement;
    var wrapW = wrap.offsetWidth;
    var gap = isMobile() ? 14 : 20;
    var cardW;
    if (isMobile()) {
      cardW = wrapW * 0.75;
    } else {
      cardW = (wrapW - gap * 3) / 2.5;
    }
    for (var i = 0; i < cards.length; i++) {
      cards[i].style.width = cardW + 'px';
    }
    return { cardW: cardW, gap: gap, wrapW: wrapW };
  }

  function calcTx(index) {
    var s = measure();
    var centerOffset = (s.wrapW - s.cardW) / 2;
    return centerOffset - index * (s.cardW + s.gap);
  }

  function setTransform(tx, animate) {
    if (animate) {
      track.style.transition = 'transform 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)';
    } else {
      track.style.transition = 'none';
    }
    track.style.transform = 'translateX(' + tx + 'px)';
  }

  /* カードの傾きを適用 */
  function applyTilt(delta) {
    var maxRotate = 3; /* 最大3度 */
    var s = measure();
    var ratio = Math.max(-1, Math.min(1, delta / s.cardW));
    var rotate = ratio * maxRotate;
    for (var i = 0; i < cards.length; i++) {
      if (i === current) {
        cards[i].style.transform = 'rotate(' + (-rotate) + 'deg)';
      }
    }
  }

  /* カードの傾きをリセット */
  function resetTilt() {
    for (var i = 0; i < cards.length; i++) {
      cards[i].style.transform = '';
    }
  }

  function goTo(i, animate) {
    current = Math.max(0, Math.min(i, total - 1));
    currentTx = calcTx(current);
    setTransform(currentTx, animate !== false);
    resetTilt();
    updateUI();
  }

  function updateUI() {
    for (var i = 0; i < navNums.length; i++) {
      navNums[i].classList.toggle('active', i === current);
    }
    for (var j = 0; j < cards.length; j++) {
      cards[j].classList.toggle('fb-inactive', j !== current);
    }
  }

  /* ナビクリック */
  if (nav) {
    nav.addEventListener('click', function (e) {
      var num = e.target.closest('.fb-nav-num');
      if (num) goTo(Number(num.dataset.index));
    });
  }

  /* ===================
     タッチイベント（スマホ）— 方向ロック付き
     =================== */
  track.addEventListener('touchstart', function (e) {
    dragging = true;
    dragDelta = 0;
    direction = null;
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    currentTx = calcTx(current);
    track.style.transition = 'none';
  }, { passive: false });

  track.addEventListener('touchmove', function (e) {
    if (!dragging) return;

    var dx = e.touches[0].clientX - startX;
    var dy = e.touches[0].clientY - startY;

    /* 方向が未確定の場合、閾値を超えたら確定 */
    if (direction === null) {
      if (Math.abs(dx) > LOCK_THRESHOLD || Math.abs(dy) > LOCK_THRESHOLD) {
        direction = Math.abs(dx) >= Math.abs(dy) ? 'horizontal' : 'vertical';
      } else {
        return; /* まだ確定しない */
      }
    }

    /* 縦スクロールと判定 → JSは何もしない */
    if (direction === 'vertical') return;

    /* 横スワイプ確定 → 縦スクロールをブロック */
    e.preventDefault();
    dragDelta = dx;
    track.style.transform = 'translateX(' + (currentTx + dragDelta) + 'px)';
    applyTilt(dragDelta);
  }, { passive: false }); /* preventDefault使うためpassive:false */

  track.addEventListener('touchend', function () {
    if (!dragging) return;
    dragging = false;
    direction = null;
    if (dragDelta === 0) { resetTilt(); return; }
    var s = measure();
    var threshold = s.cardW * 0.15;
    if (dragDelta < -threshold) goTo(current + 1);
    else if (dragDelta > threshold) goTo(current - 1);
    else goTo(current);
  });

  track.addEventListener('touchcancel', function () {
    dragging = false;
    direction = null;
    resetTilt();
    goTo(current);
  });

  /* ===================
     マウスドラッグ（PC）
     =================== */
  track.addEventListener('mousedown', function (e) {
    e.preventDefault();
    dragging = true;
    dragDelta = 0;
    direction = 'horizontal'; /* マウスは常に横 */
    startX = e.clientX;
    currentTx = calcTx(current);
    track.style.transition = 'none';
    track.style.cursor = 'grabbing';
  });

  document.addEventListener('mousemove', function (e) {
    if (!dragging) return;
    dragDelta = e.clientX - startX;
    track.style.transform = 'translateX(' + (currentTx + dragDelta) + 'px)';
    applyTilt(dragDelta);
  });

  document.addEventListener('mouseup', function () {
    if (!dragging) return;
    dragging = false;
    direction = null;
    track.style.cursor = 'grab';
    var s = measure();
    var threshold = s.cardW * 0.15;
    if (dragDelta < -threshold) goTo(current + 1);
    else if (dragDelta > threshold) goTo(current - 1);
    else goTo(current);
  });

  track.addEventListener('dragstart', function (e) { e.preventDefault(); });
  track.addEventListener('click', function (e) {
    if (Math.abs(dragDelta) > 5) e.preventDefault();
  }, true);

  /* 初期化 */
  goTo(0, false);
  window.addEventListener('resize', function () { goTo(current, false); });
})();